import React from 'react';
import { Link } from 'react-router-dom';
import './NoEncontrada.css';

function NoEncontrada() {
    return (
        <section className="no-encontrada">
            <title>Página no encontrada | DanPauleX</title>
            <meta name="robots" content="noindex" />

            <p className="no-encontrada-codigo" aria-hidden="true">404</p>
            <h1>Página no encontrada</h1>
            <p>La página que buscas no existe o ha cambiado de dirección.</p>
            <Link to="/" className="no-encontrada-boton">Volver al inicio</Link>
        </section>
    );
}

export default NoEncontrada;
